import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { PicklistService } from 'src/app/modules/core/services/picklist/picklist.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-picklist-cell',
    templateUrl: './picklist-cell.component.html',
    styleUrls: ['./picklist-cell.component.scss'],
    standalone: false
})
export class PicklistCellComponent implements OnInit {
  value: any;

  constructor(private translate: TranslateService, private picklistService: PicklistService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    if (!!params.data) {
      const value = reader.getFieldValue(field.systemName);
      if (!!value) {
        const selectedPicklistItem = field.picklistValues?.find(p => p.uId === value);
        if (!!selectedPicklistItem) {
          this.value = selectedPicklistItem.value;
          return;
        }
        if (!!field.picklistDatasetUId) {
          this.picklistService
            .getPicklistValues(field)
            .pipe(take(1))
            .subscribe(picklistValues => {
              const selectedPicklistItem = picklistValues?.find(p => p.uId === value);
              if (!!selectedPicklistItem) {
                this.value = selectedPicklistItem.value;
                this.changeDetector.markForCheck();
              }
            });
        }
      }
    } else {
      this.value = params.value;
    }
  }
}
